import TrackActions from 'app/track/TrackActions';

export default {
  stores: {},
  actions: { track: TrackActions },
  run: () => {},
};
